<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>To Laura Culley, who shares my love of Native American lore and culture.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?274a9c2d